'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggedInBadge = exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _tracking = require('@spp/tracking');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxSpid = require('@spp/redux-spid');

var _svg = require('../svg');

var _props2 = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_LOGOUT_LABEL = 'Logout';
var DEFAULT_MY_ACCOUNT_LABEL = 'My Account';
var DEFAULT_MY_SUBSCRIPTION_LABEL = 'My Subscription';

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    LOGGED_IN_BADGE_LOGOUT: 'Logged_In_Badge_Logout',
    LOGGED_IN_BADGE_MYPROFILE: 'Logged_In_Badge_MyProfile'
};

var engagementClickEvent = function engagementClickEvent(item, engagement) {
    return function (event) {
        event.preventDefault();

        engagement({
            elementIdentifier: item.event,
            meta: { name: item.name, event: event }
        });
    };
};

var LoggedInBadge = exports.LoggedInBadge = function (_Component) {
    (0, _inherits3.default)(LoggedInBadge, _Component);

    function LoggedInBadge() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoggedInBadge);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoggedInBadge.__proto__ || (0, _getPrototypeOf2.default)(LoggedInBadge)).call.apply(_ref, [this].concat(args))), _this), _this.logout = function () {
            _this.props.dispatch(_reduxSpid.actions.logout());
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LoggedInBadge, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                userLoggedInSvg = _props.userLoggedInSvg,
                mastheadExtensionButton = _props.mastheadExtensionButton,
                labels = _props.labels,
                theme = _props.theme,
                spid = _props.spid,
                myPage = _props.myPage,
                showLogoutButton = _props.showLogoutButton,
                engagement = _props.engagement,
                placement = _props.placement,
                focusable = _props.focusable;
            var _labels$logout = labels.logout,
                logoutLabel = _labels$logout === undefined ? DEFAULT_LOGOUT_LABEL : _labels$logout,
                _labels$mySubscriptio = labels.mySubscription,
                mySubscriptionLabel = _labels$mySubscriptio === undefined ? DEFAULT_MY_SUBSCRIPTION_LABEL : _labels$mySubscriptio,
                _labels$myAccount = labels.myAccount,
                myAccountLabel = _labels$myAccount === undefined ? DEFAULT_MY_ACCOUNT_LABEL : _labels$myAccount;


            var wrapperClass = theme['badge-' + placement];
            var buttonClass = focusable ? theme.badgeWrapper : theme['badgeWrapper-Open'];

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                _react2.default.createElement(
                    'button',
                    {
                        className: buttonClass,
                        onClick: function onClick(event) {
                            event.preventDefault();

                            _tracking.util.actionThenRelocateWithTimeout(engagement({
                                elementIdentifier: ENGAGEMENT_ELEMENTS.LOGGED_IN_BADGE_MYPROFILE,
                                meta: { name: myPage.name, event: event }
                            }), myPage.url);
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: theme.iconWrapper },
                        _react2.default.createElement(_svg.UserLoggedInSvg, {
                            icon: userLoggedInSvg,
                            title: mastheadExtensionButton
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.userDescription },
                        _react2.default.createElement(
                            'div',
                            { className: theme.subscriptionLabel },
                            spid.hasProduct ? mySubscriptionLabel : myAccountLabel
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                                'span',
                                null,
                                spid.givenName
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: theme.familyName },
                                spid.familyName
                            )
                        )
                    )
                ),
                showLogoutButton && _react2.default.createElement(
                    'button',
                    {
                        className: theme.logoutButton,
                        onClick: function onClick(event) {
                            engagementClickEvent({
                                event: ENGAGEMENT_ELEMENTS.LOGGED_IN_BADGE_LOGOUT,
                                name: 'Logout'
                            }, engagement)(event);

                            _this2.logout();
                        }
                    },
                    logoutLabel
                )
            );
        }
    }]);
    return LoggedInBadge;
}(_react.Component);

LoggedInBadge.IN_MASTHEAD_EXTENSION = 'mastheadExtension';
LoggedInBadge.IN_USER_MENU = 'userMenu';


if (process.env.NODE_ENV !== 'production') {
    LoggedInBadge.propTypes = {
        engagement: _propTypes2.default.func,
        spid: _propTypes2.default.shape({
            hasProduct: _propTypes2.default.bool.isRequired,
            givenName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(null)]),
            familyName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(null)])
        }).isRequired,
        labels: _propTypes2.default.shape(_props2.mastheadExtensionProps.labels).isRequired,
        myPage: _propTypes2.default.shape(_props2.mastheadExtensionProps.myPage).isRequired,
        userLoggedInSvg: _propTypes2.default.shape(_props2.svgProps).isRequired,
        mastheadExtensionButton: _propTypes2.default.oneOf(['login', 'subscribe']).isRequired,
        theme: _propTypes2.default.shape({
            badge: _propTypes2.default.string,
            logoutButton: _propTypes2.default.string,
            userDescription: _propTypes2.default.string,
            familyName: _propTypes2.default.string,
            subscriptionLabel: _propTypes2.default.string,
            badgeWrapper: _propTypes2.default.string,
            iconWrapper: _propTypes2.default.string
        }),
        dispatch: _propTypes2.default.func.isRequired,
        showLogoutButton: _propTypes2.default.bool,
        placement: _propTypes2.default.string.isRequired,
        focusable: _propTypes2.default.bool
    };
}

LoggedInBadge.defaultProps = {
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    theme: {},
    showLogoutButton: false,
    focusable: true
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        spid: state.spid
    };
})(LoggedInBadge);
//# sourceMappingURL=LoggedInBadge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/LoggedInBadge/LoggedInBadge.js
 ** module id = 598
 ** module chunks = 1
 **/